<!-- H5批注创建 -->
<template lang="pug">
van-popup.notationPopup(v-model="popupShow" closeable :overlay="false")
  .notationAdd
    .titleRow 创建批注
    .content
      van-form(ref="formData" label-width="66px")
        van-field(label="截图" readonly)
          template(#input)
            el-image.uploadpic(v-for="(url, index) in picUrlList" :key="index" :src="url" :preview-src-list="picUrlList" :z-index="9999")
        van-field(label="问题描述" input-align="right" type="textarea" autosize required v-model="question.checkContent" :rules="rule")
        van-field(label="审图要点" input-align="right" type="textarea" autosize readonly :value="question.drawingReviewPoints")
          template(#right-icon)
            van-icon.rightIcon(name="add-o" @click="openAssociatePoint")
        van-field.divide(label="关联附件" readonly)
          template(#right-icon)
            van-icon.rightIcon(name="add-o" @click="openAssociateFile")
          template(#input v-if="question.annexFileList")
            .fileList
              .file(v-for="item in question.annexFileList" :key="item.fileId")
                el-image(:src="className(item)" fit="contain" style="width: 25px;height: 25px;")
                .word {{  item.fileName  }}
                .operation(@click="delFile(item)") 删除
        van-field(label="意见类型" input-align="right" readonly is-link required :value="question.qmType" :rules="rule" @click="openQmType")
        van-field(label="严重等级" input-align="right" readonly is-link required :value="question.problemType" :rules="rule" @click="openProblemType")
        van-field(label="阶段" input-align="right" readonly is-link :value="question.stageName" @click="openStage")
        van-field(label="子项" input-align="right" readonly is-link :value="question.stageChildName" @click="openChild")
        van-field(label="专业" input-align="right" readonly is-link :value="question.specName" @click="openSpec")
        van-field(label="跨专业" input-align="right" readonly is-link :value="question.multiSpecNames" @click="openMultiSpec")
        van-field(label="修改人" input-align="right" readonly is-link required :value="question.modifierNames" :rules="rule" @click="openModifier")
      .buttons
        van-button.button(type="info" round plain @click="popupShow = false") 取消
        van-button.button(type="info" round :loading="loading" @click="create") 创建
      //- 意见类型弹框
      qmTypeSheet(ref="qmTypeSheet" @callback="setQmType")
      //- 严重等级弹框
      problemTypeSheet(ref="problemTypeSheet" @callback="setProblemType")
      //- 阶段弹框
      stageNameSheet(ref="stageNameSheet" @callback="setStage")
      //- 子项弹框
      childNameSheet(ref="childNameSheet" @callback="setChild")
      //- 专业弹框
      specNameSheet(ref="specNameSheet" @callback="setSpec")
      //- 跨专业弹框
      multiSpecSheet(ref="multiSpecSheet" :specName="question.specName" @callback="setMultiSpec")
      //- 修改人弹框
      modifierSheet(ref="modifierSheet" @callback="setModifier")
      //- 关联文件弹框
      associateFile(ref="associateFile" @callback="setFileList")
      //- 关联审图要点弹框
      associatePoint(ref="associatePoint" @callback="setPoint")
</template>

<script>
import { mapState } from "vuex";
import { tableRowIcon } from "@/CommonDP/utils/docPublic";
import { getPicFile } from "@/CommonDP/mongeView/appView/question/question.js";
import { Notify } from "vant";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import mongeService from "@/CommonDP/mongeView/service/monge-service";
import qmTypeSheet from "@/CommonDP/pages/appView/issueH5/components/qmTypeSheet.vue";
import problemTypeSheet from "@/CommonDP/pages/appView/issueH5/components/problemTypeSheet.vue";
import stageNameSheet from "@/CommonDP/pages/appView/issueH5/components/stageNameSheet.vue";
import childNameSheet from "@/CommonDP/pages/appView/issueH5/components/childNameSheet.vue";
import specNameSheet from "@/CommonDP/pages/appView/issueH5/components/specNameSheet.vue";
import multiSpecSheet from "@/CommonDP/pages/appView/issueH5/components/multiSpecSheet.vue";
import modifierSheet from "@/CommonDP/pages/appView/issueH5/components/modifierSheet.vue";
import associateFile from "@/CommonDP/pages/appView/components/associateFile/index.vue";
import associatePoint from "@/CommonDP/pages/appView/components/associatePoint/index.vue";

// 表单
function FormData() {
  return {
    autoScreenshotMd5: "", // 自动截图
    autoScreenshotFileId: "",
    autoScreenshotFileVersion: "",
    screenshotFileList: [], // 截图
    checkContent: "",
    drawingReviewPoints: "", // 审图要点
    annexFileList: [],
    qmType: "", // 意见
    qmTypeId: "",
    problemType: "", // 严重等级
    problemTypeId: "",
    stageName: "", // 阶段
    stageId: "",
    stageChildName: "", // 子项
    stageChildId: "",
    specName: "", // 专业
    specId: "",
    multiSpecList: [], // 跨专业
    multiSpecNames: "",
    modifierList: [], // 修改人
    modifierNames: ""
  };
}

export default {
  props: {
    type: { default: "" } // 批注文件类型 dwg,model,modelDwg,other
  },
  components: { qmTypeSheet, problemTypeSheet, stageNameSheet, childNameSheet, specNameSheet, multiSpecSheet, modifierSheet, associateFile, associatePoint },
  data() {
    return {
      loading: false,
      popupShow: false,
      question: new FormData(), // 问题数据
      picUrlList: [], // 批注截图url
      rule: [{ required: true, message: "该字段不能为空" }]
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  mounted() {},
  methods: {
    // 文件图标地址
    className(data) {
      let params = {
        fileType: data.fileType - "0",
        isFolder: 0,
        folderID: data.fileId
      };
      return tableRowIcon(params);
    },
    // 打开事件
    open(params) {
      this.init(params);
      this.popupShow = true;
    },
    // 初始化
    init(params) {
      let { prjId, fileId, picUrlList } = params || {};
      this.picUrlList = picUrlList || [];
      this.question = new FormData();
      this.question = { ...this.question, ...params, source: "APP端" };
      this.setPicFileList(); // 截图url => 截图文件
      this.$nextTick(() => {
        this.initPopup(prjId, fileId);
      });
      // 特殊参数：分享、流程
      let { sharerId, flowInstanceId, i } = this.$route.query || {};
      this.question = { ...this.question, userId: sharerId, flowInstanceId, shareId: i };
    },
    // 初始化弹框
    async initPopup(prjId, fileId) {
      const { data } = await mongeService.getNotationDic(prjId, fileId);
      let { qmType, qmTypeId, problemType, problemTypeId, modifierName, modifierId } = data || {};
      this.setQmType({ id: qmTypeId, name: qmType });
      this.$refs.qmTypeSheet.init(prjId, fileId);
      this.setProblemType({ id: problemTypeId, name: problemType });
      this.$refs.problemTypeSheet.init(prjId, fileId);
      this.$refs.stageNameSheet.init(prjId, fileId);
      this.$refs.childNameSheet.init(prjId, fileId);
      this.$refs.specNameSheet.init(prjId, fileId);
      this.$refs.multiSpecSheet.init(prjId, fileId);
      let list = [{ modifierName, modifierId }]; // 默认修改人
      this.setModifier(list);
      this.$refs.modifierSheet.init(prjId, "", list);
      this.$refs.associatePoint.init();
    },
    // 设置截图文件
    async setPicFileList() {
      let screenshotFileList = []; // 截图文件列表
      for (let url of this.picUrlList) {
        let picFile = await getPicFile(url);
        screenshotFileList.push(picFile);
      }
      this.question = { ...this.question, screenshotFileList };
    },

    // 删除附件
    delFile(item) {
      let list = this.question.annexFileList || [];
      this.question.annexFileList = list.filter((e) => e.fileId !== item.fileId);
    },
    // 打开意见弹框
    openQmType() {
      this.$refs.qmTypeSheet.popupShow = true;
    },
    // 设置意见
    setQmType(item) {
      let { id, name } = item || {};
      this.$set(this.question, "qmTypeId", id);
      this.$set(this.question, "qmType", name);
    },
    // 打开严重弹框
    openProblemType() {
      this.$refs.problemTypeSheet.popupShow = true;
    },
    // 设置严重
    setProblemType(item) {
      let { id, name } = item || {};
      this.$set(this.question, "problemTypeId", id);
      this.$set(this.question, "problemType", name);
    },
    // 打开阶段弹框
    openStage() {
      this.$refs.stageNameSheet.popupShow = true;
    },
    // 设置阶段
    setStage(item) {
      let { id, name } = item || {};
      this.$set(this.question, "stageId", id);
      this.$set(this.question, "stageName", name);
    },
    // 打开子项弹框
    openChild() {
      this.$refs.childNameSheet.popupShow = true;
    },
    // 设置子项
    setChild(item) {
      let { id, name } = item || {};
      this.$set(this.question, "stageChildId", id);
      this.$set(this.question, "stageChildName", name);
    },
    // 打开专业弹框
    openSpec() {
      this.$refs.specNameSheet.popupShow = true;
    },
    // 设置专业
    setSpec(item) {
      let { id, name } = item || {};
      this.$set(this.question, "specId", id);
      this.$set(this.question, "specName", name);
    },
    // 打开跨专业弹框
    openMultiSpec() {
      this.$refs.multiSpecSheet.popupShow = true;
    },
    // 设置跨专业
    setMultiSpec(list) {
      let multiSpecList = list || [];
      multiSpecList = multiSpecList.map((e) => {
        let { id, name } = e || {};
        return { specId: id, specName: name, ...e };
      });
      this.$set(this.question, "multiSpecList", multiSpecList);
      this.$set(this.question, "multiSpecNames", multiSpecList.map((e) => e.specName).join());
    },
    // 打开修改人弹框
    openModifier() {
      this.$refs.modifierSheet.popupShow = true;
    },
    // 设置修改人
    setModifier(list) {
      let multiSpecList = list || [];
      multiSpecList = multiSpecList.map((e) => {
        let { id, name } = e || {};
        return { modifierId: id, modifierName: name, ...e };
      });
      this.$set(this.question, "modifierList", multiSpecList);
      this.$set(this.question, "modifierNames", multiSpecList.map((e) => e.modifierName).join());
    },
    // 打开关联文件弹框
    openAssociateFile() {
      let { prjId } = this.question || {};
      this.$refs.associateFile.open(prjId);
    },
    // 设置关联文件
    setFileList(list) {
      let annexFileList = this.question.annexFileList || [];
      let fileList = [...annexFileList, ...list];
      this.question.annexFileList = this.unique(fileList, "fileName");
    },
    // 去重
    unique(arr, key) {
      const res = new Map();
      return arr.filter((a) => !res.has(a[key]) && res.set(a[key], 1));
    },
    // 打开审图要点弹框
    openAssociatePoint() {
      this.$refs.associatePoint.popupShow = true;
    },
    // 设置审图要点
    setPoint(item) {
      let { cnName } = item || {};
      this.$set(this.question, "drawingReviewPoints", cnName);
    },

    // 校验表单数据
    async validateFormData() {
      let flag = null;
      await this.$refs.formData
        .validate()
        .then(() => {
          flag = true; // 验证通过
        })
        .catch(() => {});
      return flag;
    },
    // 创建
    async create() {
      const validate = await this.validateFormData();
      if (!validate) return;
      switch (this.type) {
        case "dwg":
          this.popupShow = false;
          this.$toast("选择点位放置云线描述");
          mongeApiMlib.setMapText(this.question.checkContent);
          break;
        case "model":
          this.$emit("createFinish"); // 获取自动截图，完成创建
          break;
        case "modelDwg":
          this.popupShow = false;
          this.$toast("选择点位放置云线描述");
          mongeApiMlib.setMapText(this.question.checkContent);
          break;
        case "other":
          this.createFinish({});
          break;
      }
    },
    // 完成创建(补充参数)
    async createFinish(params) {
      let { autoScreenshotUrl } = params;
      if (autoScreenshotUrl) {
        let { fileMd5, fileId, fileVersion } = await getPicFile(autoScreenshotUrl);
        this.question.autoScreenshotMd5 = fileMd5 || ""; // 自动截图
        this.question.autoScreenshotFileId = fileId || "";
        this.question.autoScreenshotFileVersion = fileVersion || 1;
      }
      this.question = { ...this.question, ...params };
      try {
        this.loading = true;
        await mongeService.notationAdd(this.question);
        Notify({ type: "success", message: "创建成功！" });
        this.popupShow = false;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.notationPopup {
  position: fixed;
  top: 50px;
  bottom: 0;
  left: 0;
  transform: none;
}

.notationAdd {
  width: 100vw;
  height: 100%;
  position: relative;

  .titleRow {
    height: 46px;
    padding: 0 10px;
    line-height: 46px;
    border-bottom: 1px solid #f5f6fa;
  }
  .content {
    height: calc(100% - 46px);
    padding-top: 5px;
    overflow: auto;
    background-color: #f5f6fa;
    .uploadpic {
      width: 15vw;
      height: 15vw;
      margin-right: 1vw;
    }
    .divide {
      border-bottom: 10px solid #f5f6fa;
      padding-bottom: 12px;
    }
    .rightIcon {
      font-size: 16px;
      color: var(--theme-color, #4777e7);
    }
    .buttons {
      padding: 3vh 0;
      .button {
        width: 200px;
        height: 40px;
        margin: 0 4vw;
        max-width: 42vw;
      }
    }
  }
}

.fileList {
  width: 100%;
  max-height: 210px;
  overflow-y: auto;
  .file {
    width: 100%;
    border-bottom: 1px solid #e5e8f1;
    padding: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .word {
      width: 1px;
      flex-grow: 1;
      margin: 0 4px;
      overflow-x: auto;
      white-space: nowrap;
    }
    .operation {
      &:active {
        opacity: 0.5;
      }
      color: var(--danger-color, #f56c6c);
    }
  }
}

::v-deep .van-popup__close-icon--top-right {
  top: 12px;
  right: 12px;
}
</style>
